import React, { FC, useEffect, useState } from 'react';
import { bytesToSize } from 'utils/formatting';
import { isImageFormat, isPdfFormat } from 'utils/file';
import DOMPurify from 'dompurify';
import PdfFirstPageToPng from './PdfFirstPageToPng';

import './UploadDocuments.css';

const FilePreviewItem: FC<{
    file: File;
    onRemove: (file: File) => void;
    t: any;
}> = ({ file, onRemove, t }) => {
    const [previewUrl, setPreviewUrl] = useState<string>('');

    const isImage = isImageFormat(file);
    const isPdf = isPdfFormat(file);

    useEffect(() => {
        // Create the URL once when the component mounts or file changes
        const url = URL.createObjectURL(file);

        setPreviewUrl(url);

        // CLEANUP: This is crucial to prevent memory leaks and the "blob flood"
        return () => URL.revokeObjectURL(url);
    }, [file]);

    return (
        <li className="UploadedFilesList__Item">
            {isImage && previewUrl && (
                <div className="UploadedFilesList__Item__Preview">
                    <img src={DOMPurify.sanitize(previewUrl)} alt={file.name} />
                </div>
            )}
            {isPdf && previewUrl && (
                <div>
                    <PdfFirstPageToPng pdfUrl={previewUrl} />
                </div>
            )}
            <div className="UploadedFilesList__Item__Text">
                {file.name}
                {' '}
                <span>
                    {file.type.split('/')[1]?.toUpperCase()}
                    ,
                    {' '}
                    {bytesToSize(file.size)}
                </span>
            </div>
            <div className="UploadedFilesList__Item__Button">
                <button
                    onClick={() => onRemove(file)}
                    type="button"
                    className="UploadedFilesList__DeleteButton"
                >
                    <span className="UploadedFilesList__DeleteButton__Icon" />
                    <span className="sr-only">
                        {t('onboardingFlow.documetsPage.extinguish')}
                    </span>
                </button>
            </div>
        </li>
    );
};

export default FilePreviewItem;
